// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D1ygP5_xVhhYjI {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  width: -moz-fit-content;
  padding: 2px 4px;
  border-radius: 4px;
  background-color: var(--ds-background-accent-gray-subtler, rgba(255, 255, 255, 0.69));
  color: var(--ds-text, #172b4d);
  font-size: 11px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 16px;
}
.CffeCCwqXLj6dN {
  background-color: var(--dynamic-nav-item-pressed);
  color: var(--dynamic-text);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTemplateBadge": `D1ygP5_xVhhYjI`,
	"transparent": `CffeCCwqXLj6dN`
};
export default ___CSS_LOADER_EXPORT___;
